import React from 'react';
import axios from 'axios';
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script);
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const __DEV__ = document.domain === 'localhost';

function RazorPay() {
  async function displayRazorpay() {
    const res = await loadScript(
      'https://checkout.razorpay.com/v1/checkout.js'
    );
    if (!res) {
      alert('Please check your Internet connectivity!');
      return;
    }

    const doc = await axios.post(
      'https://razorpay-mlm.herokuapp.com/paywith/hyathi/razorpay',
      { amount: 500 }
    );

    const options = {
      key: __DEV__ ? 'rzp_test_eZTPmASulwSroU' : '', // Enter the Key ID generated from the Dashboard
      currency: doc.data.currency,
      amount: doc.data.amount,
      name: 'Grospick',
      description: 'Pay for your Order ',
      image: 'https://i.imgur.com/tjeSeOO.jpg',
      order_id: doc.data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature);
      },
      prefill: {
        name: 'Grospick',
        email: 'grospick@example.com',
        contact: '9999999999'
      }
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          onClick={displayRazorpay}
          target="_blank"
          rel="noopener noreferrer"
          href="//#endregion"
        >
          Donate Money
        </a>
      </header>
    </div>
  );
}

export default RazorPay;
